module.exports = __webpack_public_path__ + "static/media/x.9c9a4796.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-icons/x.svg
// module id = 180
// module chunks = 0